<template>
  <div>
    <van-nav-bar class="web-header base-header">
      <template #title>
        <span style="color: #fff">{{ $t("verification.title") }}</span>
      </template>
    </van-nav-bar>
    <div class="view-page" style="padding-bottom: 50px">
      <div class="game-item" v-for="(item, index) in gameitem" :key="index" @click="toLottery(item.key, item.id)">
        <van-image width="100%" height="120" :src="item.ico" fit="cover" />
        <div class="btn-icon">{{ $t('verification.benefit') }}</div>
      </div>
    </div>
    <FooterView />
  </div>
</template>

<script>
import FooterView from "../../components/Footer/index.vue";
export default {
  name: "VerificationView",
  components: { FooterView },
  data() {
    return {
      gameitem: null,
    };
  },
  mounted() {
    this.getGameItem();
  },
  methods: {
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/login' })
      } else {
        this.$router.push({ path: '/lottery?key=' + key + "&id=" + id })
      }
    },
    getGameItem() {
      this.$http({
        method: "get",
        url: "lottery_list",
      }).then((res) => {
        this.gameitem = res.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.game-item {
  width: 96%;
  margin: 10px auto;
  position: relative;
  .btn-icon{
    background-color: #ff69b4;
    text-align: center;
    padding: 5px 10px;
    border-radius: 4px;
    position: absolute;
    top: 15px;
    left:15px;
    color:#fff;
    font-size: 12px;
  }
  img {
    width: 100%;
    height: auto;
    border-radius: 10px !important;
  }
}
</style>
